'use client';
import Lottie from 'lottie-react';
import Loader from './assets/DotLoader.json';

export function LoaderDot() {
  return <Lottie animationData={Loader} loop={true} style={{ width: '50px', paddingTop: '5px' }} />;
}
